import React from "react";
import DetailedAlbumItem from "../albumList/DetailedAlbumItem"
import { useDispatch, useSelector } from "react-redux";
import { useViewport } from "../../hooks/others/useViewport";
import { isEditingQueue } from "../../reducers/randomMode";
import { Fade, styled, Tooltip } from "@mui/material";
import { Delete, Loop } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import ContainedIconButton from "../common/buttons/ContainedIconButton";
import { useRerandomizeRandomQueueItem } from "../../hooks/randomMode/useRerandomizeRandomQueuItem";
import { useDeleteRandomQueueItem } from "../../hooks/randomMode/useDeleteRandomQueueItem";
import { setRandomQueueItemContextMenu } from "../../actions/contextMenuActions";
import { RANDOM_QUEUE_ITEM_MAX_WIDTH } from "../../utils/constants/viewConstants";
import BlockingScreenLayer from "../common/containers/BlockingScreenLayer";

const EditingLayerContainer = styled(BlockingScreenLayer)(({theme}) => ({
    position: 'absolute',
    zIndex: 1,
    borderRadius: theme.shape.borderRadius
}));

const RandomQueueItemEditingLayer = ({album, queueIndex, canDeleteAlbum}) => {
    const editingMode = useSelector(isEditingQueue);

    const theme = useTheme();

    const EditingModeRerandomizeButton = () => {
        return (
            <Tooltip title="Rerandomize">
                <span>
                    <ContainedIconButton 
                        transparent="true"
                        onClick={useRerandomizeRandomQueueItem(album, queueIndex)}>
                        <Loop htmlColor={theme.palette.common.white} />
                    </ContainedIconButton>
                </span>
            </Tooltip>
        )
    }

    const EditingModeDeleteButton = () => {
        return (
            <Tooltip title={canDeleteAlbum && "Delete from queue"}>
                <span>
                    <ContainedIconButton 
                        transparent="true"
                        disabled={!canDeleteAlbum}
                        onClick={useDeleteRandomQueueItem(album, queueIndex, canDeleteAlbum)}
                    >
                        <Delete htmlColor={canDeleteAlbum ? theme.palette.common.white : ""} />
                    </ContainedIconButton>
                </span>
            </Tooltip>
        )
    }

    return (
        <Fade in={editingMode} timeout={250}>
            <EditingLayerContainer>
                <div className="d-flex flex-row jc-center ai-center gap-2 full-height full-width">
                    <EditingModeRerandomizeButton />
                    <EditingModeDeleteButton />
                </div>
            </EditingLayerContainer>
        </Fade>
    )
}

const RandomQueueItem = ({album, queueIndex, isCurrentAlbum = false, canDeleteAlbum}) => {
    const dispatch = useDispatch();

    const onClick = (e) => dispatch(setRandomQueueItemContextMenu(album, queueIndex, isCurrentAlbum, canDeleteAlbum, e));

    const maxWidth = useViewport(RANDOM_QUEUE_ITEM_MAX_WIDTH);

    return (
        <div className="full-width relative-position" style={{ maxWidth }}>
            <RandomQueueItemEditingLayer album={album} queueIndex={queueIndex} canDeleteAlbum={canDeleteAlbum} />
            <DetailedAlbumItem album={album} onClick={onClick} />
        </div>
    )
}

export default React.memo(RandomQueueItem);